export default "__VITE_ASSET__Bc_iER9B__"